import {
  DEFAULT_INVALID_FOCUS_END_TASK_INDEX,
  LOCAL_STORAGE
} from 'constants/general';
import { ToDoPlayerTask } from 'interfaces';
import { getTodoPlayerTaskDuration, safeStringify } from 'utils/helpers';
import { updateLocalStorage } from 'utils/helpers/storage';
import { filterValidPlayerTasks } from 'utils/todo-player.util';
import { FocusMode } from 'interfaces/focus-mode.interface';
import { setFocusedModes } from 'store/reducer/user/slice';
import { getAppDispatch } from 'store/store-access';

interface LoadTasksData {
  tasks?: ToDoPlayerTask[] | { tasks?: ToDoPlayerTask[] };
  total_duration?: number;
}

export const exposeLoadTasksFocusSessionEnd = () => {
  window.loadTasks = (data: LoadTasksData) => {
    const mixedData = data;
    let tasks: ToDoPlayerTask[] | null = null;

    if (Array.isArray(mixedData.tasks)) {
      // mixedData.tasks is directly the array
      tasks = mixedData.tasks;
    } else if (
      mixedData.tasks &&
      typeof mixedData.tasks === 'object' &&
      'tasks' in mixedData.tasks
    ) {
      // mixedData.tasks is an object with a tasks property
      tasks = mixedData.tasks.tasks ?? null;
    }

    // Fallback for edge case with index access
    if (!tasks && mixedData.tasks) {
      const indexed = (
        mixedData.tasks as unknown as Record<number, ToDoPlayerTask[]>
      )[DEFAULT_INVALID_FOCUS_END_TASK_INDEX];
      if (indexed) {
        tasks = indexed;
      }
    }

    const focusEndTasks = tasks
      ? filterValidPlayerTasks(tasks).map((task) => ({
          ...task,
          duration: task.duration != null ? Number(task.duration) : undefined,
          focusedDuration: task.focusedDuration
            ? Number(task.focusedDuration)
            : getTodoPlayerTaskDuration(task.duration)
        }))
      : null;

    updateLocalStorage(
      LOCAL_STORAGE.TO_DO_FOCUS_END_TASKS,
      safeStringify(focusEndTasks)
    );
  };
};

export const exposeLoadFocusNames = () => {
  window.LoadFocusNames = (data: { focusNames: FocusMode[] }) => {
    getAppDispatch()?.(setFocusedModes(data));
  };
};
